import { Link } from "react-router-dom";
import styled from "styled-components";
import { ExternalLink } from "lucide-react";

const StorageLocationCell = styled(({ className, rowData, color }) => {
  if (!rowData.storage_id) return <></>;
  return (
    <Link
      className={className}
      to={`/storage/${rowData.storage_id}`}
      state={{ from: "case:storage" }}
    >
      <div
        style={{
          display: "flex",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          {!!rowData.storage_number
            ? rowData.storage_number
            : "View Storage Item"}
        </div>
        <ExternalLink
          className="action-button"
          size={10}
          style={{ marginLeft: 5, color: "inherit" }}
        />
      </div>
    </Link>
  );
})(({ theme, rowData, color }) => ({
  color: theme.palette.primary.main,
  // hover
  "&:hover": {
    textDecoration: "underline",
  },
}));

export default StorageLocationCell;
